var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpencvIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    height: 64,
    width: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M-69.65 120.638a139.301 139.301 120 1 1 139.301 0L27.71 47.993a55.418 55.418 120 1 0-55.418 0z",
    id: "A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.275322 0 0 1.275322 -38.047246 -14.965624)"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.063405 0 0 .063405 29.66229 12.95855)",
    y: 140,
    x: 298,
    xlinkHref: "#A",
    fill: "#ff0101"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-.063405 0 0 -.063405 87.614835 65.58504)",
    y: 415,
    x: 457,
    xlinkHref: "#A",
    fill: "#0101ff"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-.031703 -.054911 .054911 -.031703 20.379704 60.225737)",
    y: 415,
    x: 142,
    xlinkHref: "#A",
    fill: "#01ff01"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpencvIcon);
export default __webpack_public_path__ + "static/media/opencv-icon.8ddaa43a5dcbf6b8dcc04ed8d571099e.svg";
export { ForwardRef as ReactComponent };